import { Button, Typography } from "@mui/material";
import { FC, useRef, useLayoutEffect, useState } from "react";
import JoditEditor from "jodit-react";
import { RTEditorProps } from "../data/RTEditorProps";
import { rtEditorToolbar } from "./configurations";

const RTEditor: FC<RTEditorProps> = ({ content, editorName, saveContent, showSaveButton = true }) => {
    const editorRef = useRef<any>(null);
    const EditorToolbar = rtEditorToolbar();
    const [editorInitialized, setEditorInitialized] = useState(false);
    const [height, setHeight] = useState(0);
    useLayoutEffect(() => {
        const container = document.querySelector('.EditorContainer');
        if (container) {
            const containerHeight = container.clientHeight;
            setHeight(containerHeight);
            setEditorInitialized(true);
        }
    }, []);

    const handleSave = () => {
        if (editorRef.current) {
            const editorContent: string = editorRef.current.value;
            saveContent(editorContent);
        }
    };

    const handleChange = (newContent: string) => {
        if (!showSaveButton) {
            saveContent(newContent);
        }
    };
    const config: any = {
        readonly: false,
        height: height,
        toolbarAdaptive: false,
        buttons: EditorToolbar,       
      }
      
    return (
        <div>
            {showSaveButton && (
                <div>
                    <Typography id="modal-modal-title" variant="h6" component="h2" align="left">
                        {editorName}
                    </Typography>
                    <br />
                </div>
            )}
            {editorInitialized && (
              <JoditEditor
                ref={editorRef}
                value={content || ''}
                config={config}
                onBlur={newContent => handleChange(newContent)}
              />
            )}
            {showSaveButton && (
                <div style={{ textAlign: 'center' }}>
                    <Button variant="contained" style={{ backgroundColor: '#4CAF50', color: 'white', margin: '10px' }} onClick={handleSave}>
                        Save
                    </Button>
                </div>
            )}
        </div>
    );
};

export default RTEditor;